import React from "react";

import { Card, LazyLoadImage, TagText, Typography } from "components";

export const NotificationPreviewCard = ({ notification }) => (
  <>
    {(notification.type === "article" || notification.type === "news" || notification.type === "feature") && (
      <Card
        className={`notification-preview-card ${notification.type === "article" ? "article" : ""}${notification.type === "news" ? "news" : ""}${
          notification.type === "feature" ? "feature" : ""
        }`}
      >
        <div className="content">
          <div className="image">
            <LazyLoadImage alt={notification.headline} src={notification.image} />
          </div>
          <div className="text">
            {notification.type === "article" && (notification.methods.length > 0 || notification.tags.length > 0) && (
              <TagText text={notification.methods.length > 0 ? notification.methods[0].method : notification.tags.length ? notification.tags[0].tag : ""} />
            )}
            <Typography variant="paragraph-m">{notification.headline}</Typography>
            {(notification.type === "news" || notification.type === "feature") && (
              <div className="description" dangerouslySetInnerHTML={{ __html: notification.description }} />
            )}
          </div>
        </div>
      </Card>
    )}
  </>
);

export default NotificationPreviewCard;
